import React from 'react';
import PropTypes from 'prop-types';

import CheckboxMUI from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const Switch = (props) => {
  const label = props.label;
  const onChange = props.onChange;
  const checked = props.checked;
  const color = props.color || 'primary';
  const disabled = props.disabled;
  const formControlSx = props.formControlSx;
  const checkBoxSx = props.checkBoxSx;
  const onMouseOver = props.onMouseOver;
  const onMouseLeave = props.onMouseLeave;
  const icon = props.icon;
  const checkedIcon = props.checkedIcon;
  const className = props.className;
  const disableRipples = props.disableRipples;

  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <FormControlLabel
      className={className}
      control={
        <CheckboxMUI
          data-testid={props['data-testid']}
          onChange={handleChange}
          checked={checked}
          color={color}
          disabled={disabled}
          icon={icon}
          checkedIcon={checkedIcon}
          sx={checkBoxSx}
          disableRipple={disableRipples}
          disableTouchRipple={disableRipples}
          disableFocusRipple={disableRipples}
        />
      }
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      sx={formControlSx}
      label={label}
    />
  );
};

Switch.propTypes = {
  label: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  formControlSx: PropTypes.object,
  checkBoxSx: PropTypes.object,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  icon: PropTypes.node,
  checkedIcon: PropTypes.node,
  className: PropTypes.string,
  disableRipples: PropTypes.bool,
  ['data-testid']: PropTypes.string,
};

export default React.memo(Switch);
